var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYaNavigatorColor = function SvgYaNavigatorColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.003,
    y: 0.064,
    fill: "#F43",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ya-navigator-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.432,
    y: 1.492,
    fill: "#F43",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ya-navigator-color_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.003 4.394a4.553 4.553 0 0 0-3.22 7.773c.823.824 2.764 2.018 2.878 3.27.017.188.153.341.342.341.188 0 .324-.154.341-.341.114-1.252 2.055-2.446 2.88-3.27a4.554 4.554 0 0 0-3.22-7.773"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F43",
    d: "M10.003 10.542a1.594 1.594 0 1 0 0-3.188 1.594 1.594 0 0 0 0 3.188"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ya-navigator-color_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.432,
    y: 1.492,
    fill: "#fff",
    rx: 2.857
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ya-navigator-color_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.932 3.636h12.143v12.143H3.932z"
  })))));
};
export default SvgYaNavigatorColor;